import { Box } from "@material-ui/core";
import * as React from "react";
import { Top } from "../components/Top/Top";
import { Author } from "../components/Author/Author";
import { Features } from "../components/Features/Features";
import { FreeChapter } from "../components/FreeChapter/FreeChapter";
import { Testimonials } from "../components/Testimonials/Testimonials";

interface Props {}

export const MarketingPage = (props: Props) => {
  return (
    <Box my={2}>
      <Top />
      <Testimonials />
      <Features />
      <FreeChapter />
      <Author />
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/pages/MarketingPage.tsx